<template>
    <v-card class="elevation-1 rounded-4">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">{{ processingText }}</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-progress-linear :value="processingValue" color="primary" determinate class="mt-0"></v-progress-linear>
        <v-card-text>
            <div class="text-xs-center green--text subheading">Successfully Processed: {{ processed }}</div>
            <div v-if="failedItems.length" class="text-xs-center red--text subheading">
                Failed: {{ failedItems.length }}
            </div>
            <v-card v-if="failedItems.length" class="elevation-1" style="border-radius:4px;">
                <v-toolbar flat height="45px">
                    <span class="red--text">Failed items.</span>
                    <span>&nbsp;Please send the Employee Ids to SweldoNow Support.</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="header_failed"
                    :items="failedItems"
                    :hide-actions="failedItems.length <= 5"
                    >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td>
                                <v-chip style="margin-left:0px;">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                </v-avatar>
                                {{ props.item.name }}
                                </v-chip>
                            </td>
                            <td>{{ props.item.employeeId }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="margin-right:10px;">
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" :disabled="loadingProcessing">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import awsS3Helper from '@/helpers/aws-s3'
export default {
    name: 'ProcessingDialogContent',
    props: {
        processingText: String,
        processingValue: Number,
        processed: Number,
        failedItems: Array,
        loadingProcessing: Boolean,
    },
    data () {
        return {
            awsS3Helper,
            header_failed: [
                {text: 'Employee',align: 'left',value: 'firstName', width: '65%', sortable: false},
                {text: 'Employee Id',align: 'left',value: 'employeeId', width: '35%', sortable: false},
            ],
        }
    },
    methods: {
        closeDialog() {
            this.$emit('ok', null)
            this.$emit('update:dialogProcessing', false)
        },
    },
}
</script>
